import React, { useMemo } from "react"
import { graphql, useStaticQuery } from "gatsby"
import Img from "gatsby-image"
import { injectIntl, FormattedMessage } from 'react-intl'
import { findLocalized } from '../utils'
import { Link } from './localizedlink'
import { Link as ScrollLink } from 'react-scroll'


const VIDEO_ID = `ss5_85rAerI`;
const IFRAME_URL = `https://www.youtube.com/embed/${VIDEO_ID}?controls=0&showinfo=0&rel=0&autoplay=1&mute=1&loop=1&playlist=${VIDEO_ID}`;

const HeroVideo = ({intl: {locale}, landing}) => {
  const { thumb, allHeroVideoYaml } = useStaticQuery(graphql`{
    thumb: file(relativePath: { eq: "photogallery/_KLA2065.jpg"}) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
    allHeroVideoYaml{
      edges{
        node{
          edition
          title
          date
          subject
          claim
          lang
        }
      }
    }    
  }`);
  const { edition, title, date, subject, claim } = useMemo(() => findLocalized(allHeroVideoYaml, locale), [allHeroVideoYaml, locale]);
  return (
    <div className={`hero-video hero-testata${landing? ' hero-testata--landing':''}`}>
      <div className="hero-video__iframe-wrapper">
        <iframe className="hero-video__iframe" width="100%" height="100%" title="Hero" src={IFRAME_URL}
          frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen>
        </iframe>
        <Img fluid={thumb.childImageSharp.fluid} className="hero-video__fallback" />
      </div>
      <div className="row">
        <div className="col-12 text-center">
          <div className="hero-video__content">
            <div className="hero-intro">
              <div className="hero-intro__edition">{edition}</div>
              <div className="hero-intro__title" itemProp="name">{title}</div>
              <div className="hero-intro__date">{date}</div>
              <div className="hero-intro__subject">{subject}</div>
              <div className="hero-intro__claim" dangerouslySetInnerHTML={{ __html: claim }}></div>
              {landing?
                <ScrollLink href="#programma" to="programma" smooth={true} title="Vai al programma" className="btn-cta btn-style-2 text-uppercase">
                  Vai al programma
                </ScrollLink>:
                <Link to="/evento/#cosa" title="dettagli" className="btn-cta btn-style-2">
                  <FormattedMessage id="dettagli" />
                </Link>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );

}

export default injectIntl(HeroVideo);